/**
 * External Dependencies
 */
import 'jquery';
import './slick/slick.min.js';
import Plyr from 'plyr';

$(document).on('ready', function () {

    isIframe();
    pageHeight();

    $(window).on('resize', function () {
        pageHeight();
    });

    /* SKIPLINK */
    $('.skiplink').find('a').on('focusin', function () {

        $('.skiplink').addClass('skiplink--expanded');

    }).on('focusout', function () {

        $('.skiplink').removeClass('skiplink--expanded');

    });/* End of SKIPLINK */

    let header = $('header');
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    /* HAMBURGER MENU */
    $('.navigation__hamburger__trigger').on('click', function () {

        if ($('.navigation').hasClass('open')) {
            $('.navigation').removeClass('open');

            $('.navigation__container').css('height', '0px');

            $(this).removeClass('btn--link--secondary');
            $(this).addClass('btn--link--primary');
            $('body').removeClass('no-scroll');

        } else {
            $('.navigation').addClass('open');

            if (iOS) {
                $('.navigation__container').css('height', $(window).innerHeight() + 'px');
            } else {
                $('.navigation__container').css('height', ($(window).innerHeight() - header.outerHeight()) + 'px');
            }

            $(this).removeClass('btn--link--primary');
            $(this).addClass('btn--link--secondary');
            $('body').addClass('no-scroll');
        }

    }); /* End of HAMBURGER MENU */

    /* CLOSE MENU ON LINK CLICK */
    $('.navigation__container__nav__menu__item > a').on('click', function () {
        if ($('.navigation').hasClass('open')) {
            $('.navigation').removeClass('open');

            $('.navigation__container').css('height', '0px');

            $('.navigation__hamburger__trigger').removeClass('btn--link--secondary');
            $('.navigation__hamburger__trigger').addClass('btn--link--primary');
            $('body').removeClass('no-scroll');
        }
    });
    /* End of CLOSE MENU ON LINK CLICK*/

    /* INPUT WCAG FOCUS */
    $('input:not([type="submit"]), textarea, select').on('keyup', function (e) {

        if (e.key === 'Tab') {
            $(this).addClass('focus-visible');
        }

    }).on('focusout', function () {

        $(this).removeClass('focus-visible');

    }); /* End of INPUT WCAG FOCUS */

    /* ANCHOR LINK SMOOTH SCROLL */
    $('a:not(.modal-cacsp-btn, .modal-cacsp-toggle-switch)[href*="#"]').on('click', function (e) {

        if ($.attr(this, 'href').indexOf('modal_form') >= 0) {
            e.preventDefault();

            $('#modal').find('.modal__container').addClass('form-modal');
            $('#modal').find($.attr(this, 'href')).addClass('active');
            $('#modal').addClass('active');

            jQuery('body').addClass('no-scroll');
        } else if ($.attr(this, 'href') != '#cookiesAndContentPolicySettings' && $.attr(this, 'href') != '#close' && $.attr(this, 'href') != '#main') {

            const id = $.attr(this, 'href').split('#')[1];

            if ($('#' + id).length > 0) {
                e.preventDefault();

                $('html, body').animate({
                    scrollTop: $('#' + id).offset().top - $('.navigation').outerHeight(),
                }, 400);
            }
        }

        return;
    }); /* End of ANCHOR LINK SMOOTH SCROLL */


    if (window.location.href.indexOf('#') > -1) {
        hashUrl(window.location.href);
    }

    const players = Plyr.setup('[id$="_player"]');

    /* CLOSE MODAL BUTTON */
    $('#modal').on('click', function (e) {
        if (e.currentTarget === e.target || $('.btn-close').find(e.target).length > 0 || $(e.target).hasClass('btn-close')) {
            e.preventDefault();
            closeModal(players);
        }
    }); /* End of CLOSE MODAL BUTTON */

    /* CUSTOM FORM LABELS */
    $('input[class^="wpforms"], textarea[class^="wpforms"]').on('focus', function () {
        $(this).addClass('custom');
        $(this).parent('.wpforms-field').addClass('wpforms-field__custom');

        if ($(this).hasClass('flatpickr-input')) {
            $(this).parent('.wpforms-datepicker-wrap').parent('.wpforms-field').addClass('wpforms-field__custom');
        }
    });

    $('input[class^="wpforms"], textarea[class^="wpforms"]').on('focusout', function () {
        if (!this.value) {
            $(this).removeClass('custom');
            $(this).parent('.wpforms-field').removeClass('wpforms-field__custom');

            if ($(this).hasClass('flatpickr-input')) {
                $(this).parent('.wpforms-datepicker-wrap').parent('.wpforms-field').removeClass('wpforms-field__custom');
            }
        }

        return;
    });

    $('.wpforms-datepicker-clear').on('click', function () {
        $(this).parent('.wpforms-datepicker-wrap').parent('.wpforms-field').removeClass('wpforms-field__custom');
    }); /* End of CUSTOM FORM LABELS */

});

function isIframe() {

    if (window.location.ancestorOrigins.length <= 0 || window.location.origin === window.location.ancestorOrigins[0]) {
        return;
    } else if (window.location.origin != window.location.ancestorOrigins[0]) {
        $('html').addClass('iframe-html');
        $('header').remove();
        $('footer').remove();
        $('.jumbotron').remove();
        $('.modal-cacsp-backdrop').remove();
        $('.modal-cacsp-position').remove();
        $('#brevo-conversations').remove();

        $('.button-container > a.btn').attr('target', '_blank');

        let paragraphs = $('.text-container > .paragraph p');

        paragraphs.each(function (i, text) {
            const parentContainer = $(text).closest('.text-container');
            const topBounds = parentContainer.offset().top;
            const bottomBounds = topBounds + parentContainer.outerHeight();
            const topPosition = $(text).offset().top;
            const bottomPosition = topPosition + $(text).outerHeight();

            if (topPosition > topBounds && bottomPosition < bottomBounds) {
                return;
            } else if (topPosition > bottomBounds) {
                return;
            } else if (topPosition > topBounds && bottomPosition > bottomBounds) {
                $(text).addClass('overflowing');

                const diff = bottomBounds - topPosition;
                const lines = Math.trunc(diff / 20);

                $(text).attr('data-lines', lines);
            }
        });
    }

    return;
}

function hashUrl(url) {
    const id = url.split('#')[1];

    if (url.indexOf('modal_form') >= 0) {

        $('#modal').find('.modal__container').addClass('form-modal');
        $('#modal').find($.attr(this, 'href')).addClass('active');
        $('#modal').addClass('active');

        jQuery('body').addClass('no-scroll');
    } else if (id != 'cookiesAndContentPolicySettings' && id != 'close' && id != 'main') {

        if ($('#' + id).length > 0) {

            $('html, body').animate({
                scrollTop: $('#' + id).offset().top - $('.navigation').outerHeight(),
            }, 400);
        }
    }

    history.replaceState(null, "", location.href.split("#")[0]);
}

function closeModal(players) {
    const modal = $('#modal');

    modal.find('.modal__container').removeClass('video-modal');
    modal.find('.modal__container').removeClass('form-modal');
    modal.find('.modal__container').removeClass('login');
    modal.find('.modal__container__video').removeClass('active');
    modal.find('.modal__container__form').removeClass('active');
    modal.find('.modal__container__login').removeClass('active');
    modal.animate({ scrollTop: 0 }, 0);
    modal.removeClass('active');

    $(players).each(function (i, play) {
        play.pause();
        play.restart();
    });

    $('body').removeClass('no-scroll');
}

/* FUNCTIONS */
function pageHeight() {
    const footerHeight = $('footer').outerHeight();
    const windowHeight = $(window).height();

    $('main').css('min-height', (windowHeight - footerHeight) + 'px');
}
